<template>
    <div>
        <div class="alert alert-success" role="alert" v-if="formSubmission.status=='successful'">
            <div class="row align-items-center">
                <div class="col-auto">{{ $t('form.contact.submission.successful') }}</div>
                <div class="col text-right">
                    <button class="btn btn-secondary btn-sm m-0" @click="formSubmission.status=null">{{ $t('form.contact.reset') }}</button>
                </div>
            </div>
        </div>

        <div class="alert alert-danger" role="alert" v-if="formSubmission.status=='failed'">
            {{ $t('form.contact.submission.failed') }}
        </div>

        <div class="alert alert-danger" role="alert" v-if="formSubmission.errors.length">
            {{ $t('form.contact.submission.invalid') }}
            <ul class="m-0 pl-3">
                <li v-for="error in formSubmission.errors">{{ error }}</li>
            </ul>
        </div>

        <form id="my-form" v-on:submit.prevent="submit" action="https://formspree.io/maypegve" v-if="formSubmission.status!='successful'" method="POST" novalidate>

            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label for="form-input-name" class="bmd-label-floating">{{ $t('form.contact.input.name') }}</label>
                        <input type="text" name="form-input-name" v-model="form.fields.name" class="form-control" id="form-input-name">
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="form-input-email" class="bmd-label-floating">{{ $t('form.contact.input.email') }}</label>
                        <input type="email" name="form-input-email" v-model="form.fields.email" class="form-control" id="form-input-email">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="form-input-message" class="bmd-label-floating">{{ $t('form.contact.input.message') }}</label>
                        <textarea class="form-control" name="form-input-message" v-model="form.fields.message" id="form-input-message" rows="4"></textarea>
                    </div>
                </div>
            </div>

            <div class="checkbox">
                <label class="text-black-50">
                  <input type="checkbox" required v-model="form.fields.privacy" name="form-input-data-privacy">{{ $t('form.contact.input.privacy') }}
                </label>
                <div class="mb-2">
                  <span class="text-muted" v-html="$t('form.contact.privacy')"></span>
                </div>
            </div>

            <button type="submit" class="btn btn-primary btn-raised">{{ $t('form.contact.input.submit') }}</button>
        </form>

    </div>
</template>

<script>
    export default {
        name: "ContactForm",
        data: function () {
            return {
                form: {
                    fields: {
                        name: '',
                        email: '',
                        message: '',
                        privacy: false,
                    }
                },
                formSubmission: {
                    status: null,
                    errors: []
                },
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
            }
        },
        methods: {
            getFormElement: function () {
                var form = document.getElementById("my-form");
                return form;
            },
            formSubmissionFailed: function () {
                this.formSubmission.status = 'failed';
            },
            formSubmissionSuccessful: function () {
                this.resetForm();
                this.formSubmission.status = 'successful';
            },
            resetForm: function () {
                var form         = this.getFormElement();
                form.reset();

                this.form.fields = {
                    name: '',
                    email: '',
                    message: '',
                    privacy: false,
                };
            },
            submit: function (ev) {
                this.formSubmission.errors = [];
                var form                   = this.getFormElement();
                var data                   = new FormData(form);

                // prevent default form actionn
                ev.preventDefault();


                if (!this.form.fields.name) {
                    this.formSubmission.errors.push(this.$t('form.contact.validation.name'));
                }
                if (!this.isEmailValid(this.form.fields.email)) {
                    this.formSubmission.errors.push(this.$t('form.contact.validation.email'));
                }
                if (!this.form.fields.message) {
                    this.formSubmission.errors.push(this.$t('form.contact.validation.message'));
                }
                if (!this.form.fields.privacy) {
                    this.formSubmission.errors.push(this.$t('form.contact.validation.privacy'));
                }

                if (this.formSubmission.errors.length == 0) {
                    // Send google event when contact form was send
                    if(this.$store.state.gdpr.accepted) {
                        this.$gtag.event('contact_form_submission', { 'event_category': 'engagement', 'event_label': 'Contact form submission' })
                    }

                    this.ajax(form.method, form.action, data, this.formSubmissionSuccessful, this.formSubmissionFailed);
                }
            },
            ajax: function (method, url, data, success, error) {
                var xhr = new XMLHttpRequest();
                xhr.open(method, url);
                xhr.setRequestHeader("Accept", "application/json");
                xhr.onreadystatechange = function () {
                    if (xhr.readyState !== XMLHttpRequest.DONE) return;
                    if (xhr.status === 200) {
                        success(xhr.response, xhr.responseType);
                    } else {
                        error(xhr.status, xhr.response, xhr.responseType);
                    }
                };
                xhr.send(data);
            },
            isEmailValid: function (email) {
                return (email == "") ? false : (this.reg.test(email)) ? true : false;
            }
        }
    }
</script>

<style scoped>

</style>
